import gColor from "./core";

let hueBlack = [
  new gColor('Black', '#000000'),
];

let hueBrown = [
  new gColor('Carnation', '#f26359'),
  new gColor('Golden Brown', '#9e6710', 'Brown'),
  new gColor('Sepia', '#704d16', 'Sepia'),
  new gColor('Sandal', '#af826a'),
  new gColor('Woody Brown', '#553d3d'),
];

let hueRed = [
  new gColor('Red', '#ff0000'),
  new gColor('Chablis', '#fff2f1'),
  new gColor('Alizarin', '#e22f24', 'Red'),
  new gColor('Cinnabar', '#e22f24'),
  new gColor('Roman', '#db6363'),
  new gColor('Thunderbird', '#d41e11'),
  new gColor('Charm', '#cc7087'),
  new gColor('Rust', '#c84d11', 'Orange'),
  new gColor('Cardinal', '#c1104b'),
  new gColor('Blush', '#bf4a67', 'Blush'),
  new gColor('French Rose', '#ec4b81'),
  new gColor('Lotus', '#854747'),
  new gColor('Tia Maria', '#ce4a09'),
  new gColor('Fire Brick', '#a5213a', 'FireBrick'),
  new gColor('Amaranth', '#cf1231'),
  new gColor('Valencia', '#d95450'),
  new gColor('Jazz', '#622b2b'),
  new gColor('Melon', '#ffafaf'),
  new gColor('Geraldine', '#eb7171'),
  new gColor('Danger', '#cf4320')
];

let hueOrange = [
  new gColor('Sunglow', '#ffcf25', 'Yellow'),
  new gColor('Flamenco', '#EC7D46'),
  new gColor('Salmon', '#ff766d'),
];

let hueYellow = [
  new gColor('Milk Punch', '#f4e7c4', 'MilkPunch'),
  new gColor('Yukon Gold', '#8c741d', 'Tan'),
  new gColor('Buttercup', '#f3b811'),
  new gColor('Mustard', '#ffdd56'),
  new gColor('Desert', '#a06c1e'),
  new gColor('Picasso', '#ffee9c'),
  new gColor('Meteor', '#C38013'),
  new gColor('Galliano', '#d2ab1f'),
  new gColor('Tussock', '#bf9045'),
];

let hueGreen = [
  new gColor('Green Pea', '#20723b', 'Laurel'),
  new gColor('Laurel', '#328538', 'Green'),
  new gColor('Elf Green', '#198663', 'Elm'),
  new gColor('Lake', '#257d93', 'Lake'),
  new gColor('De-York', '#77c077'),
  new gColor('Fruit Salad', '#55a759'),
  new gColor('Shadow', '#8a6f4d'),
  new gColor('Bilbao', '#3c810e'),
  new gColor('Mantis', '#6ac259'),
  new gColor('Swamp', '#000101'),
  new gColor('Chalet Green', '#566741'),
  new gColor('Asparagus', '#78a157'),
  new gColor('Sea Nymph', '#8db4ad'),
  new gColor('Plantation', '#3f5749'),
  new gColor('Salem', '#0f9e27'),
  new gColor('Chateau Green', '#35b660'),
  new gColor('Mountain Meadow', '#23BE8D'),
];

let hueBlue = [
  new gColor('Denim', '#0B4EAB', 'Denim'),
  new gColor('Mariner', '#3876cc', 'Blue'),
  new gColor('Alice Blue', '#fafdff'),
  new gColor('Pelorous', '#2fa0bc'),
  new gColor('Zircon', '#f8fbff'),
  new gColor('Picton Blue', '#608ed0'),
  new gColor('Steel Blue', '#5f91c1'),
  new gColor('Danube', '#5e8dcf'),
  new gColor('Malibu', '#57aeee'),
  new gColor('Summer Sky', '#3d94d6'),
  new gColor('Calypso', '#366a9b'),
  new gColor('Fun Blue', '#1953bd'),
  new gColor('Cerulean', '#00c0ff'),
  new gColor('Manatee', '#8D94B4'),
  new gColor('Ship Cove', '#777ea6'),
  new gColor('Cloud Burst', '#1e2d53'),
  new gColor('Chambray', '#4f5c7a'),
  new gColor('Biscay', '#293653'),
  new gColor('Matisse', '#215fa5'),
  new gColor('Curious Blue', '#2ea2db'),
  new gColor('Port Gore', '#394767'),
  new gColor('Mulled Wine', '#3F3F63'),
  new gColor('Royal Blue', '#4787E1'),
  new gColor('Link Water', '#EFF4FB', 'LinkWater'),
];

let hueViolet = [
  new gColor('Fuchsia', '#AF08AA', 'Fuchsia'),
  new gColor('Medium Purple', '#a773df'),
  new gColor('Blue Violet', '#994aed', 'BlueViolet'),
  new gColor('Plum', '#97308e'),
  new gColor('Amethyst', '#8e66d0'),
  new gColor('Moody Blue', '#826dd1'),
  new gColor('Purple Heart', '#7d32b0', 'DarkPurple'),
  new gColor('Revolver', '#321a3b'),
  new gColor('Electric Violet', '#c709dc'),
  new gColor('Jagger', '#462e4f'),
  new gColor('Voodoo', '#53355e'),
  new gColor('Orchid', '#DA62C2'),
  new gColor('Perfume', '#c090f4'),
  new gColor('Lavender', '#AD6CD5'),
];

let hueGrey = [
  new gColor('Gainsboro', '#d2d2d2'),
  new gColor('Antimony', '#cccccc'),
  new gColor('Silver', '#c0c0c0'),
  new gColor('Concrete', '#bcbcbc'),
  new gColor('Nobel', '#bbbbbb'),
  new gColor('Silver Chalice', '#a6a6a6', 'SilverChalice'),
  new gColor('Dusty Grey', '#999999'),
  new gColor('Seal', '#848484'),
  new gColor('Boulder', '#757575', 'Grey'),
  new gColor('Dove Grey', '#737373'),
  new gColor('Dim Grey', '#686868'),
  new gColor('Gravel', '#6e6e6e', 'Gravel'),
  new gColor('Zambezi', '#5D5D5D'),
  new gColor('Mortar', '#555555'),
  new gColor('Battleship Grey', '#535652'),
  new gColor('Emperor', '#525252'),
  new gColor('Charcoal', '#424242', 'Charcoal'),
  new gColor('Eclipse', '#3f3f3f'),
  new gColor('Night Rider', '#333333'),
  new gColor('Mine Shaft', '#2e2e2e'),
  new gColor('Nero', '#1e1e1e'),
  new gColor('Cod Grey', '#1b1b1b'),
  new gColor('Tuna', '#393C46'),
];

let hueWhite = [
  new gColor('White', '#ffffff'),
  new gColor('Cream', '#fffcd5'),
  new gColor('Floral White', '#FEFBF6'),
  new gColor('Snow', '#fcfcfc'),
  new gColor('Honeydew', '#fbfffa'),
  new gColor('Alabaster', '#f9f9f9'),
  new gColor('Wild Sand', '#f4f4f4'),
  new gColor('White Smoke', '#f7f7f7'),
  new gColor('Mercury', '#e6e6e6'),
  new gColor('Alto', '#d9d9d9'),
  new gColor('Moon', '#e3e3e3'),
  new gColor('Zinc', '#f8f8f8'),
  new gColor('Gallery', '#efefef'),
  new gColor('Cadmium', '#dddddd'),
];

let extra = [
  new gColor('Silver Chalice', '#acacac'),
];

const gColorsDB = hueBlack.concat(
  hueBrown,
  hueRed,
  hueOrange,
  hueYellow,
  hueGreen,
  hueBlue,
  hueViolet,
  hueGrey,
  hueWhite,
  extra,
);

export function gColors(color): gColor{
  return gColorsDB.find((item) => {
    if(item.label === color || item.item === color){
      return item;
    }
  });
}

export const eColors = gColorsDB.reduce((filtered, item) => {
  if(item.item){
    filtered.push(item.item);
  }
  return filtered;
}, []).concat(
  [
    "Purple",
    "LightGrey",
    "DarkGrey",
    "DarkGreen",
    "DarkBlue",
    "DarkBrown",
    "Prelorous",
  ]
);